export enum LoanMonitorRightSidePanelTabType {
    EditLoan = 'EditLoan',
}
